import { Tween, Easing } from '@tweenjs/tween.js';
export default function AnimateEntrance(vc) {
	let target = vc;
	target.y = -200;
	target.alpha = 0;

	new Tween(target)
		.to({ y: 0, alpha: 1 }, 250)
		.easing(Easing.Back.InOut)
		.start();
}
